module.exports = __webpack_public_path__ + "img/corrugatedBox8.d4458337.jpg";